import { isEmpty } from "lodash";
import { KeyPath } from "../search-group/hooks/useQuery/dto";

export function paramsRenderInitValue(params, init) {
  const { pagination, filters, sorter } = params;
  const { queryConditions: originQueryConditions, orders: originOrders } = init;

  const { pageSize, current } = pagination;
  const queryConditions = originQueryConditions.map((q) => {
    let { matchValue } = q;
    if (Object.prototype.hasOwnProperty.call(filters, q.column)) {
      if (Array.isArray(filters?.[q.column])) {
        if (!isEmpty(filters?.[q.column].filter(Boolean))) {
          matchValue = filters?.[q?.column].join(",");
        } else {
          matchValue = null;
        }
      } else {
        matchValue = filters?.[q.column];
      }
    }

    return {
      ...q,
      matchValue,
    };
  });
  const concatSorter = !isEmpty(sorter)
    ? originOrders.concat([
        {
          asc: sorter.order === "ascend",
          column: sorter.columnKey,
        },
      ])
    : originOrders;

  const orders =
    originOrders?.findIndex((order) => order.column === sorter.columnKey) > -1
      ? originOrders.map((item) => {
          if (item.column === sorter.columnKey) {
            return {
              ...item,
              asc: sorter.order === "ascend",
            };
          }
          return {
            ...item,
          };
        })
      : concatSorter;

  const newQuery = {
    current,
    size: pageSize,
    queryConditions,
    orders,
  };

  return newQuery;
}

/** 根据table配置构建初始查询值 */
export function initSearchValue({ columns, searchConfig, pagination }) {
  const { pageSize, current } = pagination;
  const orders = columns
    .filter((col) => col.sorter)
    .map((col) => {
      let asc = null;
      if (col?.defaultSortOrder === "ascend") {
        asc = true;
      } else if (col?.defaultSortOrder === "descend") {
        asc = false;
      }
      return {
        asc,
        column: col.dataIndex,
      };
    });
  const withFilterColumns = columns
    .filter(
      (col) =>
        col.renderSearch ||
        (col.filters && !col.renderSearch) ||
        col.filterDropdown
    )
    .map((col) => ({
      column: col?.searchColumns || col?.key || col?.dataIndex,
      matchType: col.matchType,
      matchValue: col?.defaultFilteredValue || null,
    }));

  if (searchConfig) {
    withFilterColumns.push({
      column: searchConfig?.column,
      matchType: searchConfig?.matchType,
      matchValue: searchConfig?.matchValue,
    });
  }

  return {
    current: current || 1,
    size: pageSize,
    queryConditions: withFilterColumns,
    orders,
  };
}

export function formatParamstoMap(params) {
  return new Map<KeyPath, any>(
    params.map((item, index) => {
      return [["queryConditions", index, "matchValue"], item.matchValue];
    })
  );
}

export function filterEmptyData(params) {
  if (isEmpty(params?.orders)) {
    delete params.orders;
  }
  const newParams = Object.keys(params).reduce((acc, key) => {
    if (key === "queryConditions") {
      return {
        ...acc,
        queryConditions: params["queryConditions"].filter(
          (query) =>
            query.matchValue !== null &&
            query.matchValue !== undefined &&
            query.matchValue !== ""
        ),
      };
    }
    return {
      ...acc,
      [key]: params[key],
    };
  }, {});

  return newParams;
}
